import { VariantProps, cva } from 'class-variance-authority';

export const environmentBannerStyles = cva(
  [
    'fixed top-0 left-0 right-0 z-40 flex items-center justify-center py-4 gap-x-8 pointer-events-none',
  ],
  {
    variants: {
      environment: {
        test: 'bg-secondary100 text-secondaryMain',
        acceptance: 'bg-error50 text-error500',
        local: 'bg-grayscale100 text-grayscale600',
        unset: 'bg-grayscale100 text-grayscale600',
      },
    },
    defaultVariants: {
      environment: 'unset',
    },
  },
);

export const environmentBannerSpinnerStyles = cva([''], {
  variants: {
    environment: {
      test: 'bg-secondaryMain',
      acceptance: 'bg-error500',
      local: 'bg-grayscale500',
      unset: 'bg-grayscale500',
    },
  },
  defaultVariants: {
    environment: 'unset',
  },
});

export type EnvironmentBannerStyles = VariantProps<
  typeof environmentBannerStyles
>;
